import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getActiveCropId } from 'current/currentSelectors';

import BaseTrigger from 'triggers/BaseTrigger';
import { getCropBasedMessage } from 'util/locale';

const baseString = 'vra-add-seed-products-trigger';
const classString = classNames({
  [`${baseString}`]: true
});
const AddSeedProductsTrigger = ({
  numActiveSeedProducts,
  onClickAddSeedProductsTrigger
}) => {
  const cropId = useSelector(getActiveCropId);
  return (
    <BaseTrigger
      className={classString}
      content={getCropBasedMessage({ key: 'button-text__add-seed', params: { num: numActiveSeedProducts }, cropId })}
      dataTestId={baseString}
      disabled={!numActiveSeedProducts}
      handler={() => { onClickAddSeedProductsTrigger(); }}
      mode='primary'
    />
  );};
AddSeedProductsTrigger.propTypes = {
  numActiveSeedProducts: PropTypes.number.isRequired,
  onClickAddSeedProductsTrigger: PropTypes.func.isRequired
};
export default AddSeedProductsTrigger;
